<template>
    <vx-card class="overflow-hidden withHover">
        <div slot="no-body">
            <div class="p-4" :class="{
              'flex justify-between flex-row-reverse items-center': iconRight,
              'text-center': !iconRight
            }">
                <feather-icon :icon="icon" class="p-3 inline-flex rounded-full" :class="[{'mb-4': !iconRight}]" :style="{background: `${color}${opacity}`,color:color}"></feather-icon>
                <div class="truncate">
                    <h2 class="'mb-1 font-bold"  :style="{color:color}" >{{ statistic }}</h2>
                    <span :style="{color:color}" >{{ title }}</span>
                </div>
            </div>
        </div>
        
    </vx-card>
</template>

<script>


export default{
  props: {
    icon: {
      type: String,
      required: true
    },
    statistic: {
      type: [Number, String],
      required: true
    },
    title: {
      type: String
    },
    color: {
      type: String,
      default: '000000'
    },
    opacity: {
      type: String,
      default:'26'
    },
    iconRight: {
      type: Boolean,
      default: false
    },
  },
  data(){
    return{
    }
  },
}
</script>

<style>
.inactive {
    border-bottom: 5px solid #FFFFFF;
}
.darkModeCard{
  border-bottom: 5px solid #BC1300;
}
.vx-card.withHover:hover {
    -webkit-transform: translateY(4px);
    transform: translateY(4px);
    -webkit-box-shadow: 0 0 5px 0 rgba(0,0,0,.1);
    box-shadow: 0 0 5px 0 rgba(0,0,0,.1);
}
</style>
